import React, {Fragment} from 'react';
import {SelectField} from "../../FormField";

class AskGeoloc extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTips: false,
        };
    }

    render() {
        return (
            <div id={"askGeoloc"}>
                <SelectField name={"country"} value={this.props.location.country._id}
                             onChange={(event) => this.props.handleLocation(event)}>
                    <option value="">Pays</option>
                    {this.props.countries.map((item) => <option value={item._id}
                                                                key={item._id}>{item.name}</option>)}
                </SelectField>
                {this.props.location.country._id && this.props.regions.length >0
                ? (<Fragment>
                        <SelectField name={"region"} value={this.props.location.region._id}
                                     onChange={(event) => this.props.handleLocation(event)}>
                            <option value="">Région</option>
                            {this.props.regions.map((item) => <option value={item._id}
                                                                      key={item._id}>{item.name}</option>)}
                        </SelectField>

                        <SelectField name={"county"} value={this.props.location.county._id}
                                     onChange={(event) => this.props.handleLocation(event)}>
                            <option value="">Département</option>
                            {this.props.counties.map((item) => <option value={item._id}
                                                                       key={item._id}>{item.name}</option>)}
                        </SelectField>

                        <SelectField name={"city"} value={this.props.location.city._id}
                                     onChange={(event) => this.props.handleLocation(event)}>
                            <option value="">Ville</option>
                            {this.props.cities.map((item) => <option value={item._id}
                                                                     key={item._id}>{item.name}</option>)}
                        </SelectField>
                    </Fragment>)
                : null}

            </div>
        )
    }
}


export default AskGeoloc;